module.exports = __webpack_public_path__ + "static/media/confirmchoices.074508a7.png";